import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
  URL_PARTNER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_PRODUCTS = `${URL_RETAILER_SCOPED}/products`
const URL_PRODUCTS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/products`
const URL_PRODUCTS_VIEW = `${URL_PRODUCTS}/view/:productId`
const URL_PRODUCTS_VIEW_DETAILS = `${URL_PRODUCTS}/view/:productId/details`
const URL_PRODUCTS_EDIT_IMAGES = `${URL_PRODUCTS}/edit-images/:productId`
const URL_PRODUCTS_VIEW_STORE_LOCATIONS = `${URL_PRODUCTS}/view/:productId/store-locations`
const URL_PRODUCTS_VIEW_AISLES = `${URL_PRODUCTS}/view/:productId/aisles`
const URL_PRODUCTS_SEARCH = `${URL_PRODUCTS}/search`
const URL_PRODUCTS_VIEW_ATTRIBUTE_OVERRIDES = `${URL_PRODUCTS_VIEW}/attribute-overrides`
const URL_PRODUCTS_VIEW_COLLECTIONS = `${URL_PRODUCTS}/view/:productId/collections`
const URL_ITEM_ANOMALY_REPORTS = `${URL_PRODUCTS}/item-anomaly`
const URL_PRODUCTS_MISSING_CODES = `${URL_PRODUCTS}/missing-codes`
const URL_PRODUCTS_MISSING_CODES_DETAILS = `${URL_PRODUCTS}/missing-codes/:missingCodeId`
const URL_PRODUCTS_LOW_PRICE_ALERTS = `${URL_PRODUCTS}/low-price-alerts`
const URL_PRODUCTS_LOW_PRICE_ALERT_DETAILS = `${URL_PRODUCTS}/low-price-alerts/:productId`
const URL_PRODUCTS_LOW_PRICE_ALERTS_DASHBOARD = `${URL_PRODUCTS_PARTNER_SCOPED}/low-price-alerts/dashboard`
const URL_PRODUCTS_AI_PRODUCT_CREATOR = `${URL_PRODUCTS}/ai-product-creator`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'products'>
  | DashRouteType<'products-view', { productId: string }>
  | DashRouteType<'products-view-details', { productId: string }>
  | DashRouteType<'products-edit-images', { productId: string }>
  | DashRouteType<'products-view-store-locations', { productId: string }>
  | DashRouteType<'products-view-aisles', { productId: string }>
  | DashRouteType<'products-search', { productId: string }>
  | DashRouteType<'products-view-attribute-overrides'>
  | DashRouteType<'products-view-collections'>
  | DashRouteType<'item-anomaly-reports'>
  | DashRouteType<'products-missing-codes'>
  | DashRouteType<'products-missing-codes-details', { missingCodeId: string }>
  | DashRouteType<'products-partner-scoped'>
  | DashRouteType<'products-low-price-alerts'>
  | DashRouteType<'products-low-price-alert-details', { productId: string }>
  | DashRouteType<'products-low-price-alerts-dashboard'>
  | DashRouteType<'products-ai-product-creator'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  products: URL_PRODUCTS,
  'products-view': URL_PRODUCTS_VIEW,
  'products-view-details': URL_PRODUCTS_VIEW_DETAILS,
  'products-edit-images': URL_PRODUCTS_EDIT_IMAGES,
  'products-view-store-locations': URL_PRODUCTS_VIEW_STORE_LOCATIONS,
  'products-view-aisles': URL_PRODUCTS_VIEW_AISLES,
  'products-search': URL_PRODUCTS_SEARCH,
  'products-view-attribute-overrides': URL_PRODUCTS_VIEW_ATTRIBUTE_OVERRIDES,
  'products-view-collections': URL_PRODUCTS_VIEW_COLLECTIONS,
  'item-anomaly-reports': URL_ITEM_ANOMALY_REPORTS,
  'products-missing-codes': URL_PRODUCTS_MISSING_CODES,
  'products-missing-codes-details': URL_PRODUCTS_MISSING_CODES_DETAILS,
  'products-low-price-alerts': URL_PRODUCTS_LOW_PRICE_ALERTS,
  'products-low-price-alert-details': URL_PRODUCTS_LOW_PRICE_ALERT_DETAILS,
  'products-partner-scoped': URL_PRODUCTS_PARTNER_SCOPED,
  'products-low-price-alerts-dashboard': URL_PRODUCTS_LOW_PRICE_ALERTS_DASHBOARD,
  'products-ai-product-creator': URL_PRODUCTS_AI_PRODUCT_CREATOR,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
